export enum ChangeReasonCodeEnum {
    NoChange = "NoChange",
    Irop = "Irop",
    ScheduleChange = "ScheduleChange",
    Move = "Move",
    VoluntaryFlyAhead = "VoluntaryFlyAhead",
    InvoluntaryFlyAhead = "InvoluntaryFlyAhead"
}
